import { useCRUDModalList } from '@/shared/hooks/useCRUDModalList';
import { useServiceStatus } from '@/contexts/service-status';
import {
  inspectionIssueTypeParamService,
  type InspectionIssueTypeParam,
  type CreateInspectionIssueTypeParamRequest,
  type UpdateInspectionIssueTypeParamRequest,
} from '@/services/inspectionIssueTypeParam.service';

const serviceAdapter = {
  getAll: () => inspectionIssueTypeParamService.getAll(),
  create: (data: CreateInspectionIssueTypeParamRequest) =>
    inspectionIssueTypeParamService.create(data).then(() => ({} as InspectionIssueTypeParam)),
  update: (id: string, data: UpdateInspectionIssueTypeParamRequest) =>
    inspectionIssueTypeParamService.update(id, data).then(() => ({} as InspectionIssueTypeParam)),
  delete: (id: string) => inspectionIssueTypeParamService.delete(id),
};

export function useInspectionIssueTypeParamList() {
  const { isServiceOnline } = useServiceStatus();
  const isInspectionServiceOnline = isServiceOnline('inspection');

  const {
    items: issueTypes,
    loading,
    isModalOpen,
    editingItem,
    submitting,
    form,
    handleNew,
    handleEdit,
    handleDelete,
    handleModalCancel,
    handleModalSubmit,
  } = useCRUDModalList<
    InspectionIssueTypeParam,
    CreateInspectionIssueTypeParamRequest,
    UpdateInspectionIssueTypeParamRequest
  >({
    service: serviceAdapter,
    entityName: 'tipo de pendência',
    enabled: isInspectionServiceOnline,
    mapToFormValues: (item) => ({
      name: item.name,
      description: item.description,
      sourceRole: item.sourceRole,
      targetRole: item.targetRole,
      isActive: item.isActive,
    }),
    mapFromFormValues: (values, isEditing) => {
      if (isEditing) {
        return {
          name: values.name as string,
          description: values.description as string,
          sourceRole: values.sourceRole as string,
          targetRole: values.targetRole as string,
          isActive: (values.isActive as boolean) ?? true,
        };
      }
      return {
        name: values.name as string,
        description: values.description as string,
        sourceRole: values.sourceRole as string,
        targetRole: values.targetRole as string,
      };
    },
    messages: {
      loadError: 'Erro ao carregar tipos de pendência',
      createSuccess: 'Tipo de pendência criado com sucesso!',
      updateSuccess: 'Tipo de pendência atualizado com sucesso!',
      deleteSuccess: 'Tipo de pendência excluído com sucesso!',
      deleteError: 'Erro ao excluir tipo de pendência',
      saveError: 'Erro ao salvar tipo de pendência',
      deleteConfirmContent:
        'Tem certeza que deseja remover este tipo de pendência? Esta ação não pode ser desfeita.',
    },
  });

  return {
    issueTypes,
    loading,
    isModalOpen,
    editingItem,
    submitting,
    form,
    handleNew,
    handleEdit,
    handleDelete,
    handleModalCancel,
    handleModalSubmit,
  };
}
